"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _constants = _interopRequireDefault(require("./constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  URLs,
  SortBy,
  INDEXED_KEYS
} = _constants.default;
class SubscriberHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "baseUrl", URLs.SUBSCRIBERS);
    _defineProperty(this, "fetchSubscribers", subId => {
      let url = this.baseUrl + (subId ? '/' + subId : '');
      return new Promise((resolve, reject) => {
        this.getInstance().get(url).then(response => {
          let subs = response.data;
          // console.log(`${subs ? subs.length : 'no '} subscribers fetched successfully`)
          resolve(subId ? subs : subs.sort(SortBy("name")));
        }).catch(err => this.handleError(err, "Error while fetching subscribers. Try again."));
      });
    });
    _defineProperty(this, "fetchSubscriber", subId => this.fetchSubscribers(subId));
  }
  patchSubscriber(subId, payload) {
    let hooks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let url = "".concat(this.baseUrl, "/").concat(subId);
    if (hooks && hooks.before) hooks.before();
    //this.nav.showOverlay();
    return new Promise((resolve, reject) => {
      this.getInstance().patch(url, payload).then(response => {
        if (hooks && hooks.after) hooks.after();
        resolve(response);
      }).catch(err => {
        if (hooks && hooks.error) hooks.error();
        // Handle; do not inform the caller
        this.handleError(err, "Error while updating subscriber. Try again.");
      }).finally(() => {
        //this.nav.hideOverlay();
      });
    });
  }
  unArchiveSubscriber(subId) {
    let hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.patchSubscriber(subId, {
      status: 'ac'
    }, hooks);
  }
  archiveSubscriber(subId) {
    let hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.patchSubscriber(subId, {
      status: 'cl'
    }, hooks);
  }
  getSubscribersCached() {
    let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this.cachedResponse(unset, INDEXED_KEYS.SUBSCRIBERS, this.fetchSubscribers);
  }
  getSubscriberCached(subId) {
    let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.getSubscribersCached(unset).then(subscribers => {
      return subscribers.filter(sub => sub._id === subId)[0];
    });
  }
  assignSubscriberToChitfund(subscriberId, subscriberName, accountId, index, oldName) {
    let payload = {
      subscriberId,
      subscriberName,
      accountId,
      index,
      oldName
    };
    let url = URLs.SUBSCRIBERS + "/assign";
    //this.nav.setActionInProgress();
    return new Promise((resolve, reject) => {
      //pre-check(s)
      if (!subscriberId || !subscriberName || !accountId || !index) {
        let msg = "Invalid data submission. Please check again.";
        //this.showError(msg);
        return reject(msg);
      }
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Subscriber assigned successfully.`)
        //this.nav.unsetActionInProgress();
        resolve(response);
      }).catch(err => {
        let msg = 'Error while assigning subscriber to this account. Please try again later.';
        this.handleError(err, msg);
        //this.nav.unsetActionInProgress();
        reject(msg);
      });
    });
  }
  unAssignSubscriberToChitfund(subscriberId, accountId, index, oldName) {
    let payload = {
      subscriberId,
      accountId,
      index,
      oldName
    };
    let url = URLs.SUBSCRIBERS + "/unassign";
    //this.nav.showOverlay();
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Subscriber un-assigned successfully.`)
        resolve(response);
      }).catch(err => {
        this.handleError(err, "Error while un-assigning subscriber to this account. Please try again later.");
        reject('error');
      }).finally(() => {
        //this.nav.hideOverlay();
      });
    });
  }
  unAssignAllSubscribersToChitfund(accountId) {
    let payload = {
      accountId
    };
    let url = URLs.SUBSCRIBERS + "/unassignAll";
    //this.nav.showOverlay();
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Subscriber un-assigned successfully.`)
        resolve(response);
      }).catch(err => {
        this.handleError(err, "Error while un-assigning all subscriber to this account. Please try again later.");
        reject('error');
      }).finally(() => {
        //this.nav.hideOverlay();
      });
    });
  }
}
exports.default = SubscriberHandler;